import { ReactElement } from 'react';
import ErrorPage from './ErrorPage';
import { ErrorService } from '../../../services/errorService';
import { useErrorService } from '../../../hooks/useErrorService';

export interface IProps {
  errorService: ErrorService;
  children: ReactElement;
}

export function FetchErrorBoundary({ errorService, children }: IProps) {
  const errors = useErrorService(errorService);

  if (errors.length) {
    const code = String(errors[0].status);
    return <ErrorPage errorCode={code} />;
  }
  return children;
}
